import LayerDrawerReducer from './LayerDrawerReducer'
import {LAYERDRAWER} from './LayerDrawerTypes'

export const changeLayerDrawer = layerDrawer => {
    return {
        type: LAYERDRAWER,
        load: layerDrawer
    }
}
export const selectNewLayerDrawer = (layerDrawer) => {

    return (dispatch) => {
        dispatch(changeLayerDrawer(layerDrawer))
    }

}